import { render } from "./LeaveBalance.vue?vue&type=template&id=2fc519c4&scoped=true&ts=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=ts"
export * from "./LeaveBalance.vue?vue&type=script&lang=ts"

import "./LeaveBalance.vue?vue&type=style&index=0&id=2fc519c4&lang=scss&scoped=true"

import exportComponent from "/home/runner/_work/SDD-gotime-web-client/SDD-gotime-web-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc519c4"]])

export default __exports__